import { render, staticRenderFns } from "./imagepicker.vue?vue&type=template&id=fbb12230&scoped=true&"
import script from "./imagepicker.vue?vue&type=script&lang=js&"
export * from "./imagepicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbb12230",
  null
  
)

export default component.exports